import { EventBus } from "../../../eventbus";
import { baseUrl } from "../../../config";

export default {
  props: {
    mySpace: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      id: this.$options.name,
      optionsData: {},
      filesToReplace: [],
      foldersToReplace: [],
      folder: null,
      selected: null,
      folders: [],
    };
  },
  created() {
    EventBus.$on(`${this.$options.name}-show`, (data) => {
      //show this overlay
      EventBus.$emit("openOverlayPage", data);

      if (data.optionsData) {
        this.optionsData = data.optionsData;
      } else {
        this.optionsData = {};
      }

      if (
        typeof data.optionsData === "object" &&
        !Array.isArray(data.optionsData)
      ) {
        //is one file or folder
        if (this.isFile) {
          //is file
          this.filesToReplace = [data.optionsData.itemData];
        } else {
          //is folder
          this.foldersToReplace = [data.optionsData.itemData];
        }
      } else {
        //are mulptiple files and/or folders
      }
    });

    EventBus.$on(`${this.$options.name}-move`, (data) => {
      if (data.id) {
        this.moveItem();
      }
    });
  },
  methods: {
    setFolders(id) {
      this.$axios
        .get(`${baseUrl}/folder?folder=${id}&myspace${this.mySpace}`, {
          responseType: "json",
        })
        .then((response) => {
          this.folders = response.data;
        });
      this.$axios
        .get(`${baseUrl}/folderdetail?folder=${id}&myspace${this.mySpace}`, {
          responseType: "json",
        })
        .then((response) => {
          this.folder = response.data;
        });
    },
    back() {
      if (this.folder == null) {
        this.openFolder(null, 1, null);
      } else {
        this.openFolder(this.folder.parent_id, 1, null);
      }
    },
    openFolder(id, count, folder) {
      if (id == null) {
        this.$axios
          .get(baseUrl + "/roots?myspace=" + this.mySpace, {
            responseType: "json",
          })
          .then((response) => {
            this.folders = response.data;
            if (this.mySpace != "1") {
              this.folders.shift();
            }
          });
        this.folder = null;
      } else {
        if (count > 0) {
          this.setFolders(id);
        } else {
          this.folder = folder;
        }
      }
    },
    moveItem() {
      const formData = new FormData();
      formData.append("myspace", this.mySpace);
      formData.append("parent", this.folder.id);
      formData.append("folders", this.foldersToReplace);
      formData.append("files", this.filesToReplace);

      if (this.folder.id == "myspace") {
        formData.set("parent", null);
      }

      this.$axios
        .post(baseUrl + "/changeparentmultiple", formData)
        .then((response) => {
          //go to folder
          this.$router.push(
            `/${this.$store.state.company}/${
              this.mySpace == "1" ? "myspace" : "home"
            }/expanded/${
              this.folder.id ? this.folder.id : this.foldersToReplace[0]
            }`
          );

          //update files
          EventBus.$emit("mobile-files-update", {});

          //close overlay
          EventBus.$emit("closeOverlayPage", { id: this.$options.name });
        });
    },
    inSelected: function(currentFolder) {
      let length = this.foldersToReplace.length;
      for (let i = 0; i < length; i++) {
        if (this.foldersToReplace[i] === currentFolder) {
          return true;
        }
      }
      return false;
    },
  },
  computed: {
    isFile() {
      return this.optionsData.extension;
    },
  },
};
